import { Box, Theme, useTheme } from '@mui/material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import tree_img from '../../assets/bad-link-tree-stump.webp';
import {
  MinorHeading,
  Subheading,
  Title
} from '../../components/shared/typography/PrimaryTypography';
import PrimaryButton from '../../components/shared/button/PrimaryButton';

/**
 * Standard 404 page for not found URL.
 * @returns {JSX.Element}
 */
const InvalidURL = () => {
  const theme: Theme = useTheme();
  const navigate: NavigateFunction = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        minHeight: '70vh'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20%' }}>
        <Title weight="Bold" sx={{ fontSize: '6rem', letterSpacing: 8 }}>
          404
        </Title>
        <img src={tree_img} width={250} />
      </Box>
      <Subheading weight="Medium" sx={{ my: 4, maxWidth: '50%' }}>
        Sorry, we were unable to find your page. Please double check that the URL is correct and try
        again later.
      </Subheading>
      <PrimaryButton
        sx={{ fontSize: 16, minWidth: 150, minHeight: 60, my: 4 }}
        onClick={() => navigate('/contact')}
      >
        Start your ESG Journey
      </PrimaryButton>
      <a href="/" style={{ textDecoration: 'none' }}>
        <MinorHeading weight="Medium" sx={{ color: theme.palette.teal.main }}>
          No thanks, take me Home
        </MinorHeading>
      </a>
    </Box>
  );
};

export default InvalidURL;
